import { createTheme } from '@mui/material/styles';

export const COLOR_PRIMARY = '#112345';
export const COLOR_DARK = '#1c345c';
export const COLOR_LIGHT = '#04bcd4';

export const PURPLE = '#bc64cc';
export const YELLOW = '#ebb600';

export const theme = createTheme({
  typography: {

    fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',

    body1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: '0',
      color: COLOR_PRIMARY,
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.8rem',
      lineHeight: 1.5,
      letterSpacing: '0',
      color: COLOR_PRIMARY,
    },
    h1: {
      fontWeight: 400,
      fontSize: '1.2rem',
      lineHeight: 1.2,
      letterSpacing: '0em',
      color: COLOR_PRIMARY,
    },
    h2: {
      fontWeight: 400,
      fontSize: '1.2rem',
      lineHeight: 1.2,
      letterSpacing: '0em',
      color: COLOR_PRIMARY,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: COLOR_DARK,
          borderColor: COLOR_DARK
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiInputLabel-outlined": {
            color: COLOR_DARK
          },
          "& .MuiAutocomplete-inputRoot": {
            color: COLOR_DARK,
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: COLOR_DARK
            }
          },
        }
      }
    }
  },
});
